import React from "react";
import { Tooltip } from "antd";

const CCTVIRTempAlarm = ({ alarmData, show2Lines=false }) => {
  // there is no alarm sensor available for this site
  if(!alarmData || alarmData.length === 0) {
    return null;
  }
  // the site has alarm sensor but there is no alarm
  var text, text2, color;
  const overHeatedCount = alarmData.reduce((acc, curr) => acc+curr, 0);
  if(alarmData.length > 1 && overHeatedCount === 0) {
    if(show2Lines) {
      text = "CCTV IR Temp Alarm";
      text2 = "All OK";
    } else {
      text = "Temp OK";
    }
    color = "green";
  }
  // the site has alarm sensor and there is at least one alarm
  if(alarmData.length > 0 && overHeatedCount > 0) {
    if(show2Lines) {
      text = "CCTV IR Temp Alarm";
      text2 = `${overHeatedCount} Sensor(s) Overheated`;
    } else {
      text = "Temp Overheated";
    }
    color = "red";
  }
  // Use Ant Design Tooltip for hover popup
  return (
    <Tooltip
      title={
        <div>
          {alarmData.map((val, idx) => (
            <div key={idx}>
              Sensor {idx + 1}:{" "}
              <span style={{ color: val === 1 ? "red" : "green" }}>
                {val === 1 ? "Overheated" : "OK"}
              </span>
            </div>
          ))}
        </div>
      }
      placement="right"
    >
      <span style={{ display: "inline-block", color: color, cursor: "pointer" }}>
        <b>{text}</b>
        {show2Lines && (
          <div>
            <span>{text2}</span>
          </div>
        )}
      </span>
    </Tooltip>
  );
};

export default CCTVIRTempAlarm;
